const url = process.env.REACT_APP_API_URL;
const url2 = process.env.REACT_APP_ENERGY_DASHBOARD_API_URL;

const resetPasswordUrl = process.env.REACT_APP_CONTACT_URL;

export default {
  contactUrl: resetPasswordUrl,
  detail: (userId) => `${url}/api/assets/${userId}/`,
  login: { url: `${url2}/api/login` },
  logout: { url: `${url}/user/logout/` },
  resetPassword: resetPasswordUrl,
  supportEmail: "service@leaftech.eu",
};
